export default "__VITE_ASSET__ow6eI0JY__"